import React, { useState, useEffect, useRef } from "react";
import { trackCheckoutEvent } from "../utils/analytics";

const KlarnaCheckout = ({ htmlMarkup }) => {
  const containerRef = useRef(null);
  const [isRendered, setIsRendered] = useState(false);

 
  const injectScripts = (container) => {
    const scripts = container.querySelectorAll("script");
    scripts.forEach((script) => {
      const newScript = document.createElement("script");
      Array.from(script.attributes).forEach((attr) => {
        newScript.setAttribute(attr.name, attr.value);
      });
      newScript.text = script.text;

      script.parentNode.appendChild(newScript);
      script.parentNode.removeChild(script);
    });
  };

  useEffect(() => {
    if (htmlMarkup && containerRef.current) {
      try {
        containerRef.current.innerHTML = "";


        containerRef.current.innerHTML = htmlMarkup;

        injectScripts(containerRef.current);

        setIsRendered(true);

        trackCheckoutEvent("checkout_initiated", {
          step: "payment_selection",
          step_index: 2,
        });
      } catch (error) {
        trackCheckoutEvent("checkout_failed", {
          step: "payment_selection",
          step_index: 2,
          error: "Failed to render Klarna checkout",
        });
        console.error("Error rendering Klarna checkout:", error);
        setIsRendered(false);
      }
    }
  }, [htmlMarkup]);

  return (
    <div
      ref={containerRef}
      className="klarna-checkout-container"
      style={{
        width: "100%",
        minHeight: "500px",
        padding: "16px",
      }}
      aria-busy={!isRendered}
    />
  );
};

KlarnaCheckout.displayName = "KlarnaCheckout";

export default KlarnaCheckout;
